var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"imprint"},[_c('router-link',{staticClass:"back-button",attrs:{"to":{ path: '/' }}},[_vm._v("Back")]),_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.data.imprint)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }